import React, { memo } from 'react';
import { Typography, Button } from '../../../../../components';

const { Paragraph, Title } = Typography;

export const ReviewAnalysisStep = memo(({ resetForm, completeStep }) => {
    return (
        <div className="review-contents">
            <Title level={2}>Review Contents</Title>
            <Paragraph>Review the imported data below from your AWS Transform analysis before proceeding.</Paragraph>
            <div className="button-group">
                <Button type="default" size="medium" onClick={resetForm}>
                    Restart
                </Button>
                <Button type="primary" size="medium" onClick={completeStep}>
                    Continue
                </Button>
            </div>
        </div>
    );
});
